import { render } from "./OtherVariant.vue?vue&type=template&id=58f223c9&scoped=true"
import script from "./OtherVariant.vue?vue&type=script&lang=js"
export * from "./OtherVariant.vue?vue&type=script&lang=js"

import "../../style.scss?vue&type=style&index=0&id=58f223c9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f223c9"]])

export default __exports__